<script>
  import {cn} from "$lib/utils.js";
  import Grid from "./bits/calendar-grid.svelte";

  let {ref = $bindable(null), class: className, ...restProps} = $props();
</script>

<Grid
  bind:ref
  class={cn("w-full border-collapse space-y-1", className)}
  {...restProps}
/>
